import React, { Component } from 'react';
import Login from './login';
import Reconnect from './reconnect';
import MainView from './mainview';
import { reconnect, logout } from '../services/APIAgent';
import { loadLanguage } from '../services/Language';

const initialState = {
	error: null,
	handle: null,
	language: null,
	loaded: false,
	loggedIn: false
};

class App extends Component {
	constructor(props, ...args) {
		super(props, ...args);

		this.state = Object.assign({}, initialState);

		this.onLoggedIn = this.onLoggedIn.bind(this);
	}
	componentDidMount() {
		return reconnect()
		.then(({ error, handle, language }) => {
			this.setState(Object.assign({}, initialState, { handle, language, loggedIn: !error }));

			if (!error && language) return loadLanguage(language);
		})
		.then(() => this.setState({ loaded: true }))
		.catch(() => this.setState(Object.assign({}, initialState, { loaded: false })));
	}

	onLoggedIn({error, handle, language, loggedIn}) {
		loadLanguage(language)
		.then(() => this.setState({ error, handle, language, loggedIn }));
	}
	logout() {
		return logout()
		.then(() => {
			this.setState(Object.assign({}, initialState, { loaded: true }));
		});
	}
	render() {
		let { loaded, loggedIn } = this.state;

		return (<div className='App'>
			{ !loaded ? <div>Loading</div> : null }
			{ loaded && !loggedIn ? <Login onLoggedIn={ this.onLoggedIn } /> : null }
			{ loaded && loggedIn ? <MainView { ...this.state } /> : null }
			<Reconnect />
		</div>);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js